<template>
  <div class="m-row" @click="handleClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MRow',
  emits: ['click'],
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped>
.m-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
</style>
